import { css } from '@huspy/styled-system/css';

export const creditStyles = {
  container: css({
    paddingY: 10,
    background: 'linear-gradient(54.66deg, #0E4160 0%, #4A7E8F 87.2%)',
    width: '100%',
  }),
  availableCreditsContainer: css({
    position: 'relative',
    width: 'fit-content',
  }),
  creditsIconContainer: css({
    position: 'absolute',
    width: '48px',
    bottom: '8px',
    right: '-45px',
  }),
};

export const bundleStyles = {
  container: css({
    borderWidth: 1,
    borderColor: 'border-secondary',
    borderRadius: 'radius-3',
    backgroundColor: 'bg-primary',
    padding: '12px',
  }),
  creditsContainer: css({
    borderRadius: 'radius-2,5',
    backgroundColor: 'utility-blue-100',
    height: '80px',
    paddingRight: '10px',
  }),
};
